import Defs from '../../../../../includes/primitives/colorDefs'
import CONST from '../../../../../includes/primitives/_constant_kaskida'
export default {
  data: () => ({
    HOST: CONST.HOST_NAME_RESOURCE + '/resources',

    canvasForm:     null,
    canvasDisc:     null,
    canvasTrend:    null,
    canvasChart:    null,
    canvasBase:     null,

    rawData:        null,
    chartData:      null,
    config:         {},
    
    Overall:        null,
    Turnover:       null,
 
    sheets:         null,
    columns:        null,
    trend:          null,

    timeline:       null,
    primary:        null,
    secondary:      null,
    chart:          null,
    legends:        null,

    toggleButton: null,
    toggle:       null,

    timeline_backup:  null,
    chart_backup:     null,
    chartData_backup: [],

    current:        {}
  }),

  computed: {
    ready2draw() {
      return (
        this.DataItems.length > 0 &&
        Object.keys(this.Canvas).length > 0
      )
    },
  },

  methods: {

    set_Gradients() {
      this.gmx_ColorV2Sets()
      this.set_Tube_Gradients()
    },

  }

}